export const CUID = {
  fondList: {
    user: 'ASvPRra9BHNHsx6EbzbHu9I',
    special: 'Adzi0.EgQDRJm40J816KBDY'
  },

  advancedFondList: {
    user: 'ASvPRra9BHNHsx6EbzbHu9I',
    special: 'Adzi0.EgQDRJm40J816KBDY',
    public: 'AdGnK.reA9RMqZl.CWhjp.0'
  },

  advancedFondListDrawer: {
    data: 'AfVknsRjnTJHpq3cYKX_aNw',
  },

  gesamtbestand: {
    treemap: 'AUTbJXFqHWVGit3fAK3UJk4',
    details: 'AQrS_Gwosd1ItpcMlKzPyq0',
  },
};
